import { useCallback, useState } from 'react'
import { createOrganization } from 'src/redux/slices/user/endpoints'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import { Button, Fade, Grid, IconButton, TextField } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'

///// Component
const TeamCreator: React.FC = () => {
  const [creatingTeam, setCreatingTeam] = useState(false)
  const [teamName, setTeamName] = useState('')
  const toggleCreatingTeam = useCallback(() => {
    setCreatingTeam((prev) => !prev)
    setTeamName('')
  }, [])
  const [trigger, { data, isLoading }] = createOrganization.useMutation()
  const handleTeamName = useCallback((e: TextFieldOnChangeEvent) => setTeamName(e.target.value), [])
  const create = useCallback(() => {
    trigger({ title: teamName })
    toggleCreatingTeam()
  }, [trigger, teamName, toggleCreatingTeam])
  return (
    <>
      {creatingTeam && (
        <Fade in={true} timeout={500}>
          <Grid container alignItems='center' spacing={2}>
            <Grid item>
              <TextField
                helperText='Enter team name'
                label='Team Name'
                value={teamName}
                onChange={handleTeamName}
              />
            </Grid>
            <Grid item>
              <Button variant='outlined' onClick={create}>
                Create
              </Button>
            </Grid>
            <Grid item>
              <IconButton onClick={toggleCreatingTeam}>
                <CancelIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Fade>
      )}

      {!creatingTeam && (
        <Button onClick={toggleCreatingTeam} variant='contained' color='primary'>
          New Team
        </Button>
      )}
    </>
  )
}

export default TeamCreator
